module.exports = __webpack_public_path__ + "static/media/SEVinstagram.0fb4a02a.jpg";